enum CargoSizeQuantityUnit {
	PER_TON = 'per_ton',
	PER_CUBIC_METER = 'per_cubic_meter',
	PER_PIECE = 'per_piece'
}

export default CargoSizeQuantityUnit
